<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { DialogClose } from "reka-ui"
import { cn } from "@/lib/utils"
import { Button } from '@/components/ui/button'

const props = withDefaults(defineProps<{
  class?: HTMLAttributes["class"]
  showCloseButton?: boolean
}>(), {
  showCloseButton: false,
})
</script>

<template>
  <div
    data-slot="dialog-footer"
    :class="cn(
      'flex flex-col-reverse gap-2 sm:flex-row sm:justify-end',
      // Бежевый футер во всю ширину (ADDENDUM §J): гасим родительский p-6 отрицательными
      // отступами, на десктопе восстанавливаем нижние скругления; на мобилке бежевое
      // тянем в safe-area (иначе под футером — белая полоса до края экрана).
      '-mx-6 -mb-6 border-t border-border-subtle bg-secondary px-6 py-4 sm:rounded-b-lg',
      'max-sm:-mb-[max(1.5rem,env(safe-area-inset-bottom))] max-sm:pb-[max(1rem,env(safe-area-inset-bottom))]',
      props.class,
    )"
  >
    <slot />
    <DialogClose v-if="showCloseButton" as-child>
      <Button variant="outline">
        Close
      </Button>
    </DialogClose>
  </div>
</template>
